import { QueryClient } from '@tanstack/react-query';

//  Theoretically there should be no problens with init right in file.
// SSR and client bundles both will have their own instance

export const queryClient = new QueryClient();
